import TaskBoard from '@/components/tasks/TaskBoard2';

export default function TaskBoardPage() {
  return <TaskBoard />;
}